import {Container} from 'aurelia-dependency-injection';
import {inject} from 'aurelia-framework';  
import {Router} from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
//import {SmtpSettingAPI} from '../../services/admin/smtpSettingAPI';
import {VerbiageSettingAPI} from '../../services/admin/verbiageSettingAPI';
import {AccountAPI} from '../../services/accountAPI';
import $ from 'jquery';
import Quill from 'quill';
@inject(AuthService, Router, VerbiageSettingAPI, UserMessageService, AccountAPI)
export class SiteParameters {
    constructor(authService, router, api, userMessageService, AccountAPI) {
        this.AccountAPI = AccountAPI;
        this.authService = authService;
        this.router = router;
        this.api = api;
        this.userMessageService = userMessageService;
        this.branded_video = "";
        this.simple_collection = "";
        this.account_id = "";
        this.whitelabel_id = "";
        this.saving = false;
        this.site_url = window.site_url;

        const account = this.authService.getAccount();
        this.biz_url = account.biz_url;
        this.bizUrl = this.biz_url;
        this.magnfiLink = this.site_url + '/biz/' + (account.biz_url ? account.biz_url : account.link_id);
    }

    attached() {
       
        var Block = Quill.import('blots/block');
        Block.tagName = 'DIV';
        Quill.register(Block, true);
        this.branded_video_editor = new Quill('#branded_video', {
            modules: {
                toolbar: [
                    [{'size': [] }, {'color': []}],  // custom dropdown
                    //['bold', 'italic', 'underline', 'code'],
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote', 'code-block'],

                    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
                    [{ 'direction': 'rtl' }],                         // text direction

                    //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    [{ 'font': [] }],
                    [{ 'align': [] }],
                    ['image', 'link']
                ]
              },
              bounds: '#scrolling-container',
            
              theme: 'snow'  // or 'bubble'
          });
          
        var Block1 = Quill.import('blots/block');
        Block1.tagName = 'DIV';
        Quill.register(Block1, true);
          this.simple_collection_editor = new Quill('#simple_collection', {
            modules: {
                toolbar: [
                    [{'size': [] }, {'color': []}],  // custom dropdown
                    //['bold', 'italic', 'underline', 'code'],
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote', 'code-block'],

                    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
                    [{ 'direction': 'rtl' }],                         // text direction

                    //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    [{ 'font': [] }],
                    [{ 'align': [] }],
                    ['image', 'link']
                ],
              },
              bounds: '#scrolling-container',
            
              theme: 'snow'  // or 'bubble'
          });
      }
    activate(params) {
        this.loading = true;
        this.userInfo = this.authService.getUser();
        this.data = {
            "account_id": this.userInfo.id,
            "whitelabel_id": this.userInfo.whitelabel_id || null
        }
        this.load();        
    }

    load() {
        this.api.getVerbiageSettings(
            this.data,
            this.authService.getUser().token, 
            this.saveLoadSuccess.bind(this), 
            this.saveLoadError.bind(this));
    }
  
    save() {
        this.saving = true;
        this.api.saveVerbiage(
            this.getData(),
            this.authService.getUser().token, 
            this.saveVerbiageSuccess.bind(this), 
            this.saveLoadError.bind(this));
        
    }

    getData() {
        //console.log('Editor ======>>>> ')
        //console.log(this.bodyEditor.container);
        let data = {
            "account_id": this.userInfo.id,
            "whitelabel_id": this.userInfo.whitelabel_id,
            "parent_wl_id": this.userInfo.whitelabel_id || null,
            "branded_video": this.branded_video_editor.container.firstChild.innerHTML,
            "simple_collection": this.simple_collection_editor.container.firstChild.innerHTML,
            "role": this.userInfo.role
        }
        console.log("verbiage data ", data);
        return data;
    }

   
    saveLoadSuccess(data) {
        console.log("verbiage", data);
        this.branded_video_editor.container.firstChild.innerHTML = data.verbiage.branded_video_verbiage;
        this.simple_collection_editor.container.firstChild.innerHTML = data.verbiage.simple_collection_verbiage;
    }

    saveVerbiageSuccess(data) {
        console.log("verbiage data", data);
        this.userMessageService.setUserMessage("user", "Saved!");
    }

    saveLoadError(msg) {
        this.userMessageService.setUserError("user", msg);
        this.loading = false;
        
    }

    saveBizUrl() {
        this.AccountAPI.saveBizUrl(
            this.bizUrl,
            this.authService.getUser().token,
            () => { 
                this.userMessageService.setUserMessage('user', 'Custom URL Saved!'); 
                this.getUpdatedUserData();
            },
            this.saveLoadError.bind(this)
        );
    }

    clickReviewPage() {
        window.open(this.magnfiLink, "_blank");
    }

    getUpdatedUserData() {
        this.AccountAPI.getByOwner(
            this.authService.getUser().token,
            this.saveLoadSuccess2.bind(this),
            this.saveLoadError.bind(this));
    }

    saveLoadSuccess2(data) {
        console.log(data);
        this.authService.setAccount(data);
        const account = this.authService.getAccount();
        console.log(account);
        this.bizUrl = account.biz_url;
        this.magnfiLink = this.site_url + '/biz/' + (account.biz_url ? account.biz_url : account.link_id);
    }  
 
}
